import { Program } from '@la/types';
import baseApi from './baseApi';

export const programApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    getSiteProgram: builder.query<
      Program,
      { siteId: string | null; programId?: number }
    >({
      query: ({ siteId, programId }) => {
        const url = `/api/sites/${siteId}/programs/${programId}?include=details,preferences`;

        return {
          url: url,
          method: 'GET',
        };
      },
    }),

    getProgramSubPrograms: builder.query<
      Program[],
      { siteId: string | null; programId?: number }
    >({
      query: ({ siteId, programId }) => {
        const url = `/api/sites/${siteId}/programs/${programId}/subPrograms`;

        return {
          url: url,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetSiteProgramQuery, useGetProgramSubProgramsQuery } =
  programApi;
